import {
    DataParamsApi,
    deleteDataParams,
    useDataParams,
    controlActivitiesListDataParamsCodecMap,
} from "@impero-com/ui/domain";

import {
    ControlActivitiesScope,
    buildControlActivitiesListDataParamsDefaults,
    buildControlActivitiesListTableStateStorageKey,
} from "./consts";

type CodecMap = typeof controlActivitiesListDataParamsCodecMap;

export interface ControlActivitiesDataParamsApi extends DataParamsApi<CodecMap> {
    deleteKeysFromQueryParams: (params: URLSearchParams) => void;
}

export function useControlActivitiesDataParams(
    scope: ControlActivitiesScope
): ControlActivitiesDataParamsApi {
    const dataParams = useDataParams(
        buildControlActivitiesListTableStateStorageKey(scope),
        controlActivitiesListDataParamsCodecMap,
        buildControlActivitiesListDataParamsDefaults(scope)
    );

    return {
        ...dataParams,
        deleteKeysFromQueryParams: (params) =>
            deleteDataParams(params, controlActivitiesListDataParamsCodecMap),
    };
}
